import React from "react";

import NotificationPortalModal from "@components/NotificationPortalModal";

import useNotificationPortalInternal from "../hook/useNotificationPortalInternal";
import { NotificationPortalContext } from "../hook/useNotificationPortal";

const NotificationPortalProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const portal = useNotificationPortalInternal();

  const {
    state: { open, currentNotification, hasNext },
    action: { handleClose, handleNext },
  } = portal;

  return (
    <NotificationPortalContext.Provider value={portal}>
      {children}

      <NotificationPortalModal
        open={open}
        notification={currentNotification}
        hasNext={hasNext}
        onClose={handleClose}
        onNext={handleNext}
      />
    </NotificationPortalContext.Provider>
  );
};

export default NotificationPortalProvider;
